import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

var NewTabIcon = /*#__PURE__*/function (_Component) {
  _inherits(NewTabIcon, _Component);

  var _super = _createSuper(NewTabIcon);

  function NewTabIcon() {
    var _this;

    _classCallCheck(this, NewTabIcon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      var url = _this.props.url;
      var win = window.open(url, '_blank');
      win.focus();
    });

    return _this;
  }

  _createClass(NewTabIcon, [{
    key: "render",
    value: function render() {
      if (this.props.render) {
        return this.props.render(this.handleClick);
      }

      var icon = this.props.icon || "ic icon-ic_info2";
      return /*#__PURE__*/React.createElement("div", {
        id: "new-tab-icon",
        className: "".concat(this.props.className || '', " block"),
        onClick: this.handleClick
      }, /*#__PURE__*/React.createElement("i", {
        className: icon
      }));
    }
  }]);

  return NewTabIcon;
}(Component);

NewTabIcon.propTypes = {
  className: PropTypes.string,
  render: PropTypes.func,
  url: PropTypes.string.isRequired,
  icon: PropTypes.string
};
export default NewTabIcon;